import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import { IBreadcrumb, TPage } from '../../types/helper';

import * as styles from './index.css';

export interface IBreadcrumbsStoreProps {
  breadcrumbs: IBreadcrumb[] | null;
  page: TPage;
}

export interface IBreadcrumbsDispatchProps {
  redirectPage(page: TPage): void;
}

export type TBreadcrumbs = IBreadcrumbsStoreProps & IBreadcrumbsDispatchProps;

export class Breadcrumbs extends React.Component<TBreadcrumbs, {}> {
  private handleOnClick = (page: TPage) => {
    this.props.redirectPage(page);
  }

  public render() {
    const { breadcrumbs, page } = this.props;
    if (!breadcrumbs) {
      return null;
    }

    const breadcrumbsToRender = (breadcrumbs || []).map((breadcrumb, index) => {
      return (
        <span
          {...mergeStyles([
            styles['link_wrapper'],
            (breadcrumb.page !== page) && styles['link-active'],
          ])}
          itemProp="itemListElement"
          key={`breadcrumb_${index}`}
        >
        {
          <span
            itemProp="name"
            className={styles['link']}
            onClick={() => (this.handleOnClick(breadcrumb.page))}
          >
            {breadcrumb.title}
          </span>
        }
          <meta itemProp="position" content={`${index + 1}`} />
      </span>
      );
    });

    return (
      <div
        className={styles['breadcrumbs']}
      >
        {breadcrumbsToRender}
      </div>
    );
  }
}
